export class CumulativeValuesModel {
  charges: number = 0;
  inssRps: number = 0;
  inssRpsIn25: number = 0;
}
